var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.213 10.904v7.508h16.25v-7.508M9.338 1.198v12.184m0 0L5.9 9.316m3.439 4.066l3.436-4.066",
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxOSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCgk8cGF0aCBkPSJNMS4yMTI4OSAxMC45MDM2TDEuMjEyODkgMTguNDEySDYuMjEyODlIMTIuNDYzMkgxNy40NjI5VjEwLjkwMzYiIHN0cm9rZT0iIzAwMDA2NCIgc3Ryb2tlLXdpZHRoPSIxLjUiDQoJCXN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPg0KCTxwYXRoIGQ9Ik05LjMzNzg5IDEuMTk3NzVMOS4zMzg4MyAxMy4zODIxTTkuMzM4ODMgMTMuMzgyMUw1LjkwMDM5IDkuMzE2MTlNOS4zMzg4MyAxMy4zODIxTDEyLjc3NTQgOS4zMTYxOSINCgkJc3Ryb2tlPSIjMDAwMDY0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+DQo8L3N2Zz4=";
export { SvgIconDownload as ReactComponent };